
export default {
  name: 'flights',
  layout: 'index',
  transition: 'fade',
};
